export default __webpack_public_path__ + "static/media/Group502-Yono.56f5989a.png";